import { faFileInvoiceDollar, faHouse, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function BottomNav({onQRScannerClicked}) {
  const navigate = useNavigate();
  const notification = useToastContext();
  
  const setSelection = (tag) => {
    //setSelectedItem(tag);
  };

  const { t } = useTranslation();
  return (
    <div className="md:hidden bg-backdrop fixed z-40 w-full h-16 -translate-x-1/2 bg-neutral-primary-soft border-t border-default bottom-0 left-1/2">
      <div className="grid h-full max-w-lg grid-cols-3 mx-auto">
        <button
          onClick={() => {
            setSelection("home");
            navigate("/dashboard");
          }}
          data-tooltip-target="tooltip-home"
          type="button"
          className="inline-flex flex-col items-center justify-center px-5 rounded-s-full hover:bg-neutral-secondary-medium group"
        >
          <FontAwesomeIcon icon={faHouse} size="xl" />
          <span class={`text-xs font-medium`}>{t("NAV_HOME")}</span>
        </button>
        <div
          id="tooltip-home"
          role="tooltip"
          className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium  transition-opacity duration-300 bg-dark rounded-base shadow-xs opacity-0 tooltip"
        >
          <span className="">{t("NAV_HOME")}</span>
          <div className="tooltip-arrow" data-popper-arrow></div>
        </div>
        <div className="flex items-center justify-center">
          <button
            data-tooltip-target="tooltip-new"
            type="button"
            className="inline-flex items-center justify-center bg-brand hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs rounded-full focus:outline-none"
            onClick={() => {
              onQRScannerClicked()
            }}
          >
            <FontAwesomeIcon icon={faQrcode} size={"2xl"} />
            <span className="sr-only">{t("NAV_SCAN")}</span>
          </button>
        </div>
        <button
          onClick={() => {
            setSelection("payments");
            navigate("/payments");
          }}
          data-tooltip-target="tooltip-payments"
          type="button"
          className="inline-flex flex-col items-center justify-center px-5 rounded-e-full hover:bg-neutral-secondary-medium group"
        >
          <FontAwesomeIcon icon={faFileInvoiceDollar} size="xl" />
          <span class={`text-xs font-medium `}>{t("NAV_PAYMENTS")}</span>
        </button>
        <div
          id="tooltip-payments"
          role="tooltip"
          className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium  transition-opacity duration-300 bg-dark rounded-base shadow-xs opacity-0 tooltip"
        >
          <span className=""></span>
          <div className="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>
    </div>
  );
}

export default BottomNav;
